import * as React from 'react';
import { RescheduleAppointmentContext } from './context.js';

const RescheduleAppointmentProvider = ({ opco , googleMapsApiKey , storesUrl , bookAppointmentUrl , cancelAppointmentUrl , token , appointmentDisplayType , appointmentId , appointmentTypes , offerFallbackImageUrl , children ,  })=>{
    const [appointment, setAppointment] = React.useState(undefined);
    const [store, setStore] = React.useState(undefined);
    const [selectedTimeSlot, setSelectedTimeSlot] = React.useState(undefined);
    const values = React.useMemo(()=>({
            config: {
                opco,
                googleMapsApiKey,
                storesUrl,
                bookAppointmentUrl,
                cancelAppointmentUrl,
                token,
                appointmentId,
                appointmentTypes,
                offerFallbackImageUrl,
                appointmentDisplayType
            },
            store,
            appointment,
            selectedTimeSlot,
            setStore,
            setAppointment,
            setSelectedTimeSlot
        })
    , [
        opco,
        googleMapsApiKey,
        storesUrl,
        bookAppointmentUrl,
        cancelAppointmentUrl,
        token,
        appointmentId,
        appointmentTypes,
        offerFallbackImageUrl,
        appointmentDisplayType,
        store,
        appointment,
        selectedTimeSlot,
        setStore,
        setAppointment,
        setSelectedTimeSlot, 
    ]);
    return /*#__PURE__*/ React.createElement(RescheduleAppointmentContext.Provider, {
        value: values
    }, children);
};

export { RescheduleAppointmentProvider };
//# sourceMappingURL=provider.js.map
